<template>
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
          :tbody-tr-class="rowClass"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template v-if="newPolicyGroupBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea una
                  nuova Polizza cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewPolicyGroup"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                ><b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea</b-button
                >
              </div>
            </template>
            <template v-else>
              <div
                :class="`text-center empty-results ${
                  isTableInModal ? 'my-3' : 'my-5'
                }`"
              >
                <div
                  v-if="
                    isTableInModal ||
                    performedSearch ||
                    automaticPerformedSearch
                  "
                  class="mb-1"
                >
                  Non sono stati trovati risultati
                </div>
                <template v-else-if="!isTableInModal">
                  <b-button
                    class="btn btn--smaller"
                    variant="primary"
                    size="sm"
                    title="Ricerca libera"
                    data-type="special-btn"
                    @click="freeSearch"
                  >
                    Nuova ricerca libera</b-button
                  >
                  <span class="or">oppure</span>
                  <b-button
                    :class="`btn--smaller btn--transparent align-items-center gap-3${
                      filterCount ? ' active' : ''
                    }`"
                    size="sm"
                    title="Apri i filtri"
                    data-type="special-btn"
                    v-b-toggle.sidebar-1
                  >
                    <base-icon name="filters" width="23" height="23" />Ricerca
                    con filtri{{ filterCount ? ` (${filterCount})` : "" }}
                  </b-button>
                </template>
              </div>
            </template>
          </template>
          <template #cell(anagrafica)="{ item }" v-if="items.length">
            <span v-for="(registry, i) in item.registries" :key="registry.id">
              <span
                v-if="
                  !Array.isArray(registry.attributables) &&
                  !registry.attributables.length
                "
                >{{
                  registry.status_registry.value === 1
                    ? registry.attributables.CNAM
                    : registry.attributables.SURN +
                      " " +
                      registry.attributables.NAME
                }}{{ i == item.registries.length - 1 ? "" : ", " }}</span
              >
            </span>
          </template>
          <template #cell(actionRow)="row" v-if="items.length">
            <b-button
              size="sm"
              variant="lisaweb"
              @click="onChosen(row.item)"
              class="mt-1 mr-1"
              title="Aggiungi"
            >
              Aggiungi
            </b-button>
          </template>
          <template #cell(rowSelector)="row">
            <div class="action-buttons" v-if="!isPrimary(row.item)">
              <b-button
                size="sm"
                variant="lisaweb"
                @click="onChosen(row.item)"
                class="mt-1 mr-1 ml-auto"
                title="Imposta come Principale"
              >
                <base-icon name="primary" width="22"></base-icon>
              </b-button>
            </div>
            <div class="action-buttons" v-else>
              <b-button
                size="sm"
                variant="lisaweb"
                disabled
                class="mt-1 mr-1 ml-auto"
                title="Principale"
              >
                <base-icon name="primary" width="22"></base-icon>
              </b-button>
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye" width="22"></base-icon>
              </b-button>
              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id)"
                class="mt-1 mr-1"
                title="Modifica"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id)"
                class="mt-1 mr-1"
                title="Elimina"
              >
                <base-icon name="trash" width="22" height="22"></base-icon>
              </b-button>
            </div>
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
                >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                  page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }}</span>
              </template>
              <template v-slot:first-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                  ><base-icon
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                  ><base-icon
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
      <b-modal
        :id="infomodalName"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        scrollable
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <button-group-tab></button-group-tab>
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import template from "./template";
import BaseIcon from "@/components/BaseIcon";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import General from "@/components/wallet/registry-groups/details/General";
import BaseInputPagination from "@/components/form/BaseInputPagination";

export default {
  name: "PolicyGroupsTable",
  extends: template,
  data() {
    return {
      tabs: [{ name: "General", text: "Generale" }],
      selected: "General", // dynamically load selected component in tabs
      modalResourceId: null, // prop for the dynamic components
      tabIndex: 0, // remember last visited tab: set active tab when modal gets opened
    };
  },
  components: {
    BaseIcon,
    General,
    ButtonGroupTab,
    BaseInputPagination,
  },
  props: {
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    newPolicyGroupBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // highlight the row if primary is 'Y',
    // only when showing the registry_group index filtered with filterOn byRegistry
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (!item.registries) return;
      // let registry_id = this.getRegistryId();
      // if (!registry_id) return;
      // return item.registries.find((r) => r.id == registry_id).pivot.primary
      //   .value === "Y"
      //   ? "table-success-lisaweb"
      //   : "";
      return this.isPrimary(item) ? "table-success-lisaweb" : "";
    },
    onAddNewPolicyGroup() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    getRegistryId() {
      let registry_id;
      const filter = this.$parent.$parent.$data.filter;
      if (filter && Object.keys(filter).length) {
        registry_id = filter.byRegistry.id;
      }
      return registry_id;
    },
    isPrimary(item) {
      let found = item.registries.find((r) => r.id == this.getRegistryId());
      if (found) {
        return found.pivot.primary.value === "Y";
      }
      return false;
    },
    customized(item) {
      let c = {};
      c.gruppo = item.code;
      c.titolo = item.title;
      let array_ana = [];
      if (item.registries) {
        Object.keys(item.registries).forEach((i) => {
          let anagrafiche = item.registries[i];
          let anagrafica =
            anagrafiche.status_registry.value === 1
              ? anagrafiche.attributables.CNAM
              : anagrafiche.attributables.NAME +
                " " +
                anagrafiche.attributables.SURN;
          array_ana.push(anagrafica);
        });
        c.anagrafica = array_ana.join(", ");
      }

      let customAttributes = this.convertFromCustomAttributesToFields(
        this.customAttributes()(this.repository)
      );

      if (customAttributes) {
        Object.keys(customAttributes).forEach((i) => {
          let value = customAttributes[i].key.split(".");
          let label = customAttributes[i].label;
          c[label] = item.attributables[value[value.length - 1]]; // get always the last split element
        });
      }

      return c;
    },
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>
